<template>
    <div class="edit-quick-inline">
        <div v-if="isEditing" class="d-flex align-items-center" :class="{ 'flex-column': type === 'textarea' }">
            <slot name="input"></slot>
            <div :class="type === 'textarea' ? 'mt-1' : 'ml-1 d-flex align-items-center'">
                <i class="ri-checkbox-circle-line text-success fs-20 cursor-pointer" @click="$emit('save')" title="Save"></i>
                <i
                    class="ri-close-circle-line text-danger fs-20 cursor-pointer"
                    :class="type === 'textarea' ? 'ml-2' : 'ml-1'"
                    @click="$emit('cancel')"
                    title="Cancel"
                ></i>
            </div>
        </div>
        <div v-else class="el-table__cell d-flex align-items-center w-100 h-100" v-b-tooltip.hover :title="tooltip">
            <slot name="display"></slot>
            <i v-if="showEditIcon" class="ri-edit-box-line ml-auto cursor-pointer edit-icon-inline" @click="$emit('start')"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InlineEditWrapper',
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        showEditIcon: {
            type: Boolean,
            default: true
        },
        tooltip: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'input'
        }
    }
};
</script>

<style scoped></style>
